/* eslint-disable camelcase */

import {
  AvailabilityData,
  AvailabilityMatchScore,
  AvailabilitySlot
} from '../types/TherapistAvailabilityWidget';
import IndividualTherapyIcon from '../../../assets/icons/icon-individual-therapy.svg';
import GroupTherapyIcon from '../../../assets/icons/icon-groupTherapy.svg';
import CouplesTherapyIcon from '../../../assets/icons/icon-couples-therapy.svg';
import FamilyTherapyIcon from '../../../assets/icons/icon-family-therapy.svg';
import AssessmentTherapyIcon from '../../../assets/icons/icon-testing-assessment.svg';
import PsychiatryTherapyIcon from '../../../assets/icons/icon-psychiatry.svg';
import { GetUserTimeZone } from './timeZone';
import moment from 'moment';
import { TherapistAvailabilityWidgetEnum } from '../components/TherapistAvailabilityWidget/TherapistAvailabilityWidgetEnum';
import { BookAppointmentUniqueKeyEnum } from '../constants';

export const AvailablilityFilterAndSortSlots = (
  data: AvailabilityData,
  filtered_match_scores: AvailabilityMatchScore[],
) => {
  const { date_requested_utc } = data;

  const detectedTimeZone = GetUserTimeZone();

  const convertToTimeZone = (dateTime: string, timeZone: string) => {
    return moment.utc(dateTime).tz(timeZone).format();
  };

  const groupedSlots: { [key: string]: AvailabilitySlot[] } =
    date_requested_utc.reduce((acc, date) => {
      const convertedDate = convertToTimeZone(date, detectedTimeZone);
      const dateStr = moment(convertedDate).format('YYYY-MM-DD');

      acc[dateStr] = [];

      Array.isArray(filtered_match_scores) &&
        filtered_match_scores.forEach(match => {
          const slotsForDate = match.slots_data?.filter(slot => {
            const convertedSlotDateTime = convertToTimeZone(
              slot.slot_start_date_time,
              detectedTimeZone,
            );

            return (
              moment(convertedSlotDateTime).format('YYYY-MM-DD') === dateStr
            );
          });

          if (slotsForDate && slotsForDate.length > 0) {
            slotsForDate.sort((a, b) => {
              const timeA = moment(
                convertToTimeZone(a.slot_start_date_time, detectedTimeZone),
              ).format('HH:mm:ss');
              const timeB = moment(
                convertToTimeZone(b.slot_start_date_time, detectedTimeZone),
              ).format('HH:mm:ss');

              return timeA.localeCompare(timeB);
            });
            acc[dateStr].push(...slotsForDate);
          }
        });

      return acc;
    }, {} as { [key: string]: AvailabilitySlot[] });

  return Object.entries(groupedSlots).map(([date, slots]) => {
    const result: { [key: string]: AvailabilitySlot[] } = {};

    result[date] = slots;

    return result;
  });
};

export const getSlotDetials = (
  selectedService: any,
  setSlotRenderDetails: (details: { icon: string; background: string }) => void,
) => {
  const slotRenderDetails = { icon: '', background: '' };

   if(selectedService?.label.toLowerCase().includes('testing')){
           slotRenderDetails.icon = AssessmentTherapyIcon;
                  slotRenderDetails.background =
                      "linear-gradient(225deg, #BDC2C8 0%, #929AA6 100%)";
      }else{
          switch (selectedService?.unique_key) {
              case BookAppointmentUniqueKeyEnum.INDIVIDUAL_THERAPY:
                  slotRenderDetails.icon = IndividualTherapyIcon;
                  slotRenderDetails.background =
                      " linear-gradient(225deg, #26ECB0 0%, #0FCC93 100%), linear-gradient(225deg, #E99EF9 0%, #AE53E4 100%)";
                  break;
  
              case BookAppointmentUniqueKeyEnum.COUPLES_THERAPY:
                  slotRenderDetails.icon = CouplesTherapyIcon;
                  slotRenderDetails.background =
                      "linear-gradient(225deg, #58DDE0 0%, #2FC5CA 100%)";
                  break;
  
              case BookAppointmentUniqueKeyEnum.FAMILY_THERAPY:
                  slotRenderDetails.icon = FamilyTherapyIcon;
                  slotRenderDetails.background =
                      "linear-gradient(225deg, #9EADFF 0%, #6C7BEA 100%)";
                  break;
  
              case BookAppointmentUniqueKeyEnum.GROUP_THERAPY:
                  slotRenderDetails.icon = GroupTherapyIcon;
                  slotRenderDetails.background =
                      "linear-gradient(225deg, #E99EF9 0%, #AE53E4 100%)";
                  break;
  
              case BookAppointmentUniqueKeyEnum.PSYCHIATRY_THERAPY:
                  slotRenderDetails.icon = PsychiatryTherapyIcon;
                  slotRenderDetails.background =
                      "linear-gradient(225deg, #FF8F8F 0%, #DE5959 100%)";
                  break;
  
              case BookAppointmentUniqueKeyEnum.ASSESMENT_THERAPY:
                  slotRenderDetails.icon = AssessmentTherapyIcon;
                  slotRenderDetails.background =
                      "linear-gradient(225deg, #BDC2C8 0%, #929AA6 100%)";
                  break;
  
              default:
                  slotRenderDetails.icon = AssessmentTherapyIcon;
                  slotRenderDetails.background =
                      "linear-gradient(225deg, #BDC2C8 0%, #929AA6 100%)";
                  break;
          }
      }
  
          setSlotRenderDetails(slotRenderDetails);
};

export const hasMoreThanFourSlots = (
  formattedData: { [key: string]: AvailabilitySlot[] }[],
) => {
  return formattedData.some(dateSlots => {
    const slots = Object.values(dateSlots)[0];

    return slots.length > 4;
  });
};

export const convertDateAndTimeForAvailabilityWidget = (
  dateString: string,
): string => {
  try {
    if (typeof dateString !== 'string') {
      throw new Error('Invalid date string input');
    }

    // Get user's timezone offset in minutes
    const userTimeZoneOffset = -new Date().getTimezoneOffset(); // Negative to match ISO format

    // Convert offset to "+/-HH:mm" format
    const offsetHours = Math.floor(Math.abs(userTimeZoneOffset) / 60);
    const offsetMinutes = Math.abs(userTimeZoneOffset) % 60;
    const offsetSign = userTimeZoneOffset >= 0 ? '+' : '-';
    const formattedOffset = `${offsetSign}${String(offsetHours).padStart(
      2,
      '0',
    )}:${String(offsetMinutes).padStart(2, '0')}`;

    // Replace the existing timezone offset with the user's timezone offset
    const updatedDateString = dateString.replace(
      /([+-]\d{2}:\d{2})$/,
      formattedOffset,
    );

    return updatedDateString;
  } catch (error) {

    console.error(error);

    return dateString; // Return original string if any error occurs
  }
};

export const isSameDateForAvailabilityWidget = (
  dateString1: string,
  dateString2: string,
): boolean => {
  try {
    // Convert both date strings to Date objects
    const date1 = new Date(dateString1);
    const date2 = new Date(dateString2);

    // Check if both dates are valid
    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
      throw new Error('Invalid date format');
    }

    // Extract YYYY-MM-DD parts and compare
    const formattedDate1 = date1.toISOString().split('T')[0];
    const formattedDate2 = date2.toISOString().split('T')[0];

    return formattedDate1 === formattedDate2;
  } catch (error) {

    console.error(error);

    return false; // Return false in case of an error
  }
};

export const GetTherapistAvailabilityPayload = (
  selectedInsuranceData: any,
  selectedClientAgeData: any,
  selectedServiceTypeData: any,
  GetUserTimeZone: () => string,
  startDateAndTime: any,
  profileId: any,
) => {
  const payload =
    selectedInsuranceData[0] &&
    selectedInsuranceData[0]?.place_holder ===
      TherapistAvailabilityWidgetEnum?.No_Insurance
      ? {
          filters: [
            {
              sequence: 35,
              filter_key: TherapistAvailabilityWidgetEnum?.ageGroup,
              filter_label: TherapistAvailabilityWidgetEnum?.work_with_ages,
              filter_sub_header:
                TherapistAvailabilityWidgetEnum?.work_with_age_groups,
              filter_component_type:
                TherapistAvailabilityWidgetEnum?.single_select,
              filter_group: TherapistAvailabilityWidgetEnum?.commonly_used,
              locked: false,
              skip_for_self_match: false,
              is_grouped: false,
              filter_selection_data: [selectedClientAgeData[0]],
            },
          ],
          schedule_request: {
            start_date: startDateAndTime,
            callAPI: true,
            time_from: null,
            time_until: null,
            schedule_day: [],
            schedules_with_slots: false,
            for_days: 3,
            user_time_zone: GetUserTimeZone(),
            sort_by: TherapistAvailabilityWidgetEnum?.MOST,
            meeting_pref: [
              TherapistAvailabilityWidgetEnum?.Online_or_In_Person,
            ],
            service_type: `${selectedServiceTypeData[0]?.unique_key}`,
          },
          therapist_id: profileId,
          is_clinician_availability_page: false,
          client_id: '',
        }
      : {
          filters: [
            {
              sequence: 35,
              filter_key: TherapistAvailabilityWidgetEnum?.ageGroup,
              filter_label: TherapistAvailabilityWidgetEnum?.work_with_ages,
              filter_sub_header:
                TherapistAvailabilityWidgetEnum?.work_with_age_groups,
              filter_component_type:
                TherapistAvailabilityWidgetEnum?.single_select,
              filter_group: TherapistAvailabilityWidgetEnum?.commonly_used,
              locked: false,
              skip_for_self_match: false,
              is_grouped: false,
              filter_selection_data: [selectedClientAgeData[0]],
            },
            {
              sequence: 20,
              filter_key: TherapistAvailabilityWidgetEnum?.insurancePlan,
              filter_label: TherapistAvailabilityWidgetEnum?.All_Insurance_Plan,
              filter_sub_header: TherapistAvailabilityWidgetEnum?.INSURANCES,
              filter_component_type:
                TherapistAvailabilityWidgetEnum?.multi_checkbox,
              filter_group: TherapistAvailabilityWidgetEnum?.commonly_used,
              locked: false,
              skip_for_self_match: false,
              is_grouped: false,
              filter_selection_data: [selectedInsuranceData[0]],
            },
          ],
          schedule_request: {
            start_date: startDateAndTime,
            callAPI: true,
            time_from: null,
            time_until: null,
            schedule_day: [],
            schedules_with_slots: false,
            for_days: 3,
            user_time_zone: GetUserTimeZone(),
            sort_by: TherapistAvailabilityWidgetEnum?.MOST,
            meeting_pref: [
              TherapistAvailabilityWidgetEnum?.Online_or_In_Person,
            ],
            service_type: `${selectedServiceTypeData[0]?.unique_key}`,
          },
          therapist_id: profileId,
          is_clinician_availability_page: false,
          client_id: '',
        };

  return payload;
};
